import { recipeV2Client } from '../../../app/services/api/recipeV2';

/**
 * Hook that provides Recipe V2 API methods.
 * Calls go through the governed service client. Offline Demo Mode read fallbacks
 * are explicit in the list/detail loaders; writes continue to use this client.
 */
const useRecipeV2Api = () => {
  return recipeV2Client;
};

export default useRecipeV2Api;
